var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ModelDto } from './model';
import { IsNotEmpty, IsEnum, IsEmail, IsUrl, IsArray, ValidateIf, IsPositive, IsOptional, MaxLength, IsNumber } from 'class-validator';
import { assign } from 'lodash';
export var GroupAccessStatus;
(function (GroupAccessStatus) {
    GroupAccessStatus[GroupAccessStatus["OPEN"] = 1] = "OPEN";
    GroupAccessStatus[GroupAccessStatus["PARTIALLY_OPEN"] = 2] = "PARTIALLY_OPEN";
    GroupAccessStatus[GroupAccessStatus["CLOSED"] = 3] = "CLOSED";
})(GroupAccessStatus || (GroupAccessStatus = {}));
export var GroupAccessStatusRegister;
(function (GroupAccessStatusRegister) {
    GroupAccessStatusRegister[GroupAccessStatusRegister["OPEN"] = 1] = "OPEN";
    GroupAccessStatusRegister[GroupAccessStatusRegister["CLOSED"] = 3] = "CLOSED";
})(GroupAccessStatusRegister || (GroupAccessStatusRegister = {}));
export var GroupViewVisiblity;
(function (GroupViewVisiblity) {
    GroupViewVisiblity[GroupViewVisiblity["VISIBLE"] = 1] = "VISIBLE";
    GroupViewVisiblity[GroupViewVisiblity["INVISIBLE"] = 2] = "INVISIBLE";
})(GroupViewVisiblity || (GroupViewVisiblity = {}));
export var GroupType;
(function (GroupType) {
    GroupType[GroupType["GROUP"] = 1] = "GROUP";
    GroupType[GroupType["CLUB"] = 2] = "CLUB";
    GroupType[GroupType["INSTITUTION"] = 3] = "INSTITUTION";
    GroupType[GroupType["BUSINESS"] = 4] = "BUSINESS";
    GroupType[GroupType["LOCAL_GOVERNMENT"] = 5] = "LOCAL_GOVERNMENT";
})(GroupType || (GroupType = {}));
export var GroupSubType;
(function (GroupSubType) {
    GroupSubType[GroupSubType["COUNSELING"] = 1] = "COUNSELING";
    GroupSubType[GroupSubType["HEALTHCARE"] = 2] = "HEALTHCARE";
    GroupSubType[GroupSubType["RELIGION"] = 3] = "RELIGION";
    GroupSubType[GroupSubType["CULTURE"] = 4] = "CULTURE";
    GroupSubType[GroupSubType["POLITICAL_PARTY"] = 5] = "POLITICAL_PARTY";
    GroupSubType[GroupSubType["LAW_ENFORCEMENT"] = 6] = "LAW_ENFORCEMENT";
    GroupSubType[GroupSubType["EDUCATION"] = 7] = "EDUCATION";
})(GroupSubType || (GroupSubType = {}));
export var GroupRole;
(function (GroupRole) {
    GroupRole[GroupRole["ADMINISTRATOR"] = 1] = "ADMINISTRATOR";
    GroupRole[GroupRole["MODERATOR"] = 2] = "MODERATOR";
    GroupRole[GroupRole["MEMBER"] = 3] = "MEMBER";
})(GroupRole || (GroupRole = {}));
export var GroupJoinRequestStatus;
(function (GroupJoinRequestStatus) {
    GroupJoinRequestStatus[GroupJoinRequestStatus["PENDING"] = 1] = "PENDING";
    GroupJoinRequestStatus[GroupJoinRequestStatus["APPROVED"] = 2] = "APPROVED";
    GroupJoinRequestStatus[GroupJoinRequestStatus["DENIED"] = 3] = "DENIED";
})(GroupJoinRequestStatus || (GroupJoinRequestStatus = {}));
export var GroupSubscriptionPillFilters;
(function (GroupSubscriptionPillFilters) {
    GroupSubscriptionPillFilters[GroupSubscriptionPillFilters["ALL"] = 0] = "ALL";
    GroupSubscriptionPillFilters[GroupSubscriptionPillFilters["GROUPS"] = 1] = "GROUPS";
    GroupSubscriptionPillFilters[GroupSubscriptionPillFilters["CLUBS"] = 2] = "CLUBS";
    GroupSubscriptionPillFilters[GroupSubscriptionPillFilters["INSTITUTIONS"] = 3] = "INSTITUTIONS";
    GroupSubscriptionPillFilters[GroupSubscriptionPillFilters["BUSINESSES"] = 4] = "BUSINESSES";
})(GroupSubscriptionPillFilters || (GroupSubscriptionPillFilters = {}));
export var GroupSubTypeFilter;
(function (GroupSubTypeFilter) {
    GroupSubTypeFilter[GroupSubTypeFilter["ALL"] = 0] = "ALL";
    GroupSubTypeFilter[GroupSubTypeFilter["COUNSELING"] = 1] = "COUNSELING";
    GroupSubTypeFilter[GroupSubTypeFilter["HEALTHCARE"] = 2] = "HEALTHCARE";
    GroupSubTypeFilter[GroupSubTypeFilter["RELIGION"] = 3] = "RELIGION";
    GroupSubTypeFilter[GroupSubTypeFilter["CULTURE"] = 4] = "CULTURE";
    GroupSubTypeFilter[GroupSubTypeFilter["POLITICAL_PARTY"] = 5] = "POLITICAL_PARTY";
    GroupSubTypeFilter[GroupSubTypeFilter["LAW_ENFORCEMENT"] = 6] = "LAW_ENFORCEMENT";
    GroupSubTypeFilter[GroupSubTypeFilter["EDUCATION"] = 7] = "EDUCATION";
})(GroupSubTypeFilter || (GroupSubTypeFilter = {}));
export var GroupSortFilter;
(function (GroupSortFilter) {
    GroupSortFilter["ASCENDING"] = "ASC";
    GroupSortFilter["DESCENDING"] = "DESC";
})(GroupSortFilter || (GroupSortFilter = {}));
var GroupDto = /** @class */ (function (_super) {
    __extends(GroupDto, _super);
    function GroupDto(group) {
        var _this = _super.call(this, group) || this;
        if (group) {
            _this.name = group.name;
            _this.accessStatus = group.access_status;
            _this.type = group.type;
            _this.subType = group.sub_type;
            _this.description = group.description;
            _this.shortDescription = group.short_description || '';
            _this.zipCode = group.zip_code;
            _this.streetName = group.street_name;
            _this.houseNumber = group.house_number;
            _this.city = group.city;
            _this.visibility = group.visibility;
        }
        else {
            _this.shortDescription = '';
            _this.accessStatus = 0;
            _this.type = 0;
        }
        return _this;
    }
    GroupDto.prototype.toRestModel = function () {
        var superModel = _super.prototype.toRestModel.call(this);
        superModel.name = this.name;
        superModel.access_status = this.accessStatus;
        superModel.type = this.type;
        superModel.sub_type = this.subType;
        superModel.description = this.description;
        superModel.short_description = this.shortDescription;
        superModel.zip_code = this.zipCode;
        superModel.street_name = this.streetName;
        superModel.house_number = this.houseNumber;
        superModel.city = this.city;
        superModel.visibility = this.visibility;
        return superModel;
    };
    GroupDto.prototype.toGqlModel = function (merge) {
        var superModel = _super.prototype.toGqlModel.call(this, merge);
        return assign(superModel, {
            name: this.name,
            access_status: this.accessStatus,
            type: this.type,
            sub_type: this.subType,
            description: this.description,
            short_description: this.shortDescription,
            zip_code: this.zipCode,
            street_name: this.streetName,
            house_number: this.houseNumber,
            city: this.city,
            visibility: this.visibility,
        }, merge);
    };
    // TODO: Remove later, used in admin app
    GroupDto.prototype.toModel = function () {
        return this.toGqlModel();
    };
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], GroupDto.prototype, "name", void 0);
    __decorate([
        IsEnum(GroupAccessStatus),
        ValidateIf(function (group) { return group.type === GroupType.GROUP; }),
        __metadata("design:type", Number)
    ], GroupDto.prototype, "accessStatus", void 0);
    __decorate([
        IsEnum(GroupType),
        __metadata("design:type", Number)
    ], GroupDto.prototype, "type", void 0);
    __decorate([
        ValidateIf(function (group) { return group.type !== GroupType.GROUP; }),
        IsPositive(),
        __metadata("design:type", Number)
    ], GroupDto.prototype, "subType", void 0);
    __decorate([
        IsNotEmpty(),
        MaxLength(150),
        __metadata("design:type", String)
    ], GroupDto.prototype, "shortDescription", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], GroupDto.prototype, "description", void 0);
    __decorate([
        IsNumber(),
        __metadata("design:type", Number)
    ], GroupDto.prototype, "zipCode", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], GroupDto.prototype, "streetName", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], GroupDto.prototype, "houseNumber", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], GroupDto.prototype, "city", void 0);
    __decorate([
        IsEnum(GroupViewVisiblity),
        ValidateIf(function (group) { return group.type === GroupType.GROUP; }),
        __metadata("design:type", Number)
    ], GroupDto.prototype, "visibility", void 0);
    return GroupDto;
}(ModelDto));
export { GroupDto };
var ExtendedGroupDto = /** @class */ (function (_super) {
    __extends(ExtendedGroupDto, _super);
    function ExtendedGroupDto(group) {
        var _a, _b;
        var _this = _super.call(this, group) || this;
        if (group) {
            _this.email = group.email;
            _this.phone = group.phone;
            _this.url = group.url;
            _this.offers = group.group_offers || [];
            _this.attachments = (_b = (_a = group.attachments) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { return attachment.id; })) !== null && _b !== void 0 ? _b : [];
        }
        else {
            _this.offers = [];
            _this.attachments = [];
        }
        return _this;
    }
    ExtendedGroupDto.prototype.toRestModel = function () {
        var superModel = _super.prototype.toRestModel.call(this);
        superModel.email = this.email;
        superModel.phone = this.phone;
        superModel.url = this.url;
        superModel.group_offers = this.offers;
        superModel.attachments = this.attachments;
        return superModel;
    };
    ExtendedGroupDto.prototype.toGqlModel = function (merge) {
        var superModel = _super.prototype.toGqlModel.call(this, merge);
        return assign(superModel, {
            email: this.email,
            phone: this.phone,
            url: this.url,
            group_offers: this.offers,
        }, merge);
    };
    __decorate([
        IsEmail(),
        IsOptional(),
        __metadata("design:type", String)
    ], ExtendedGroupDto.prototype, "email", void 0);
    __decorate([
        IsOptional(),
        __metadata("design:type", String)
    ], ExtendedGroupDto.prototype, "phone", void 0);
    __decorate([
        IsUrl(),
        IsOptional(),
        __metadata("design:type", String)
    ], ExtendedGroupDto.prototype, "url", void 0);
    __decorate([
        IsArray(),
        __metadata("design:type", Array)
    ], ExtendedGroupDto.prototype, "offers", void 0);
    __decorate([
        IsArray(),
        IsOptional(),
        __metadata("design:type", Array)
    ], ExtendedGroupDto.prototype, "attachments", void 0);
    return ExtendedGroupDto;
}(GroupDto));
export { ExtendedGroupDto };
